// extracted by mini-css-extract-plugin
export default {"wrapper":"oVlTJ","contentWrapper":"_8Ll9","video":"rK16s","text":"_CjwY","link":"tLLkI"};